<template>
  <section class="content-categories-default">
    <Breadcrumb :links="links"/>
    <div class="content-categories-default-body">
      <div class="row">
        <div class="col-12 col-sm-6 col-lg-4 col-xl-3" v-for="category in ebooksCategories" :key="category.id">
          <CardCategory :category="category" :isType="'Ebooks'"/>
        </div>
      </div>
    </div>
    <ModalDelete/>
  </section>
</template>

<script>
import Breadcrumb from '@/components/breadcrumb/Index';
import CardCategory from '@/components/cards/CardCategory';
import ModalDelete from '@/components/modals/ModalDelete';
import { mapGetters, mapActions } from 'vuex';

export default {
  data() {
    return {
      links: [
        {
          name: 'Ebooks',
          routerName: 'Ebooks'
        },
        {
          name: 'Categorias',
          routerName: 'ListEbooksCategories'
        },
      ],
    }
  },
  components: {
    Breadcrumb,
    CardCategory,
    ModalDelete
  },
  computed: {
    ...mapGetters('Ebooks', ['ebooksCategories'])
  },
  methods: {
    ...mapActions('Ebooks', ['consultCategoriesEbooks', 'registerCategoryEbooks'])
  },
  mounted() {
    this.consultCategoriesEbooks();
  }
}
</script>

<style lang="scss">
</style>
